import { ChangeDetectionStrategy, ChangeDetectorRef, Component, input, Input, OnDestroy, OnInit } from "@angular/core";

import { WebhookFormInputComponent } from "../webhook-form-input/webhook-form-input.component";
import { WebhookCommonComponent } from "../common.components";

@Component({
    selector: 'webhook-form-tag',
    templateUrl: './webhook-form-tag.component.html',
    styleUrl: './webhook-form-tag.component.scss',
    standalone: false
})

export class WebhookFormTagComponent extends WebhookCommonComponent implements OnInit, OnDestroy {
   
    


}